import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home/Home';
import About from './components/About/About';
import Services from './components/services/Services';
import Contact from './components/contact/Contact';
import Admission from './components/admissions/Admission';
import Terrms from './components/Terms/Terrms';
import Notfound from './components/404/Notfound';
import Join from './components/Join/Join';
import JoinDetails from './components/Join/JoinDetails';
import ScrollToTop from './components/Common/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/admissions" element={<Admission />} />
      <Route path="/terms-and-conditions" element={<Terrms />} />

      <Route path="/join-us" element={<Join />} />
      <Route path="/join-us/:slug" element={<JoinDetails />} />

      
      <Route path="*" element={<Notfound />} />
    </Routes>
    </BrowserRouter>
  );
}

export default App;
